import { useCallback } from 'react';

export function useCopyToClipboard() {
    return useCallback(async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (err) {
            return false;
        }
    }, []);
}
